<template>
  <div class="min-h-screen bg-muted/30">
    <div class="container mx-auto px-4 py-12">
      <UiCard class="mx-auto max-w-2xl">
        <UiCardHeader>
          <UiCardTitle>{{ $t('myReports.title') }}</UiCardTitle>
          <UiCardDescription>{{ $t('myReports.description') }}</UiCardDescription>
        </UiCardHeader>
        <UiCardContent>
          <MyReportsList
            :reports="reports"
            :is-loading="isLoading"
            :labels="labels"
          />
        </UiCardContent>
      </UiCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { definePageMeta, useI18n, useSeoMeta } from '#imports';
import { useConvexQuery } from '#composables/useConvex';
import { api } from '@convex/_generated/api';
import MyReportsList from '#bubba/shared/components/legal/MyReportsList.vue';
import type { MyReportsLabels } from '#bubba/shared/components/legal/MyReportsList.vue';

definePageMeta({ middleware: ['auth'] });

const { $t, $ts, $localeRoute } = useI18n();

useSeoMeta({ title: () => $ts('myReports.seoTitle') });

const { data: reportsData, isLoading } = useConvexQuery(
  api.feedback.contentReports.getMyReports,
  {},
);

const reports = computed(() => reportsData.value ?? []);

const labels = computed((): MyReportsLabels => ({
  empty: $ts('myReports.empty'),
  emptyDescription: $ts('myReports.emptyDescription'),
  notified: $ts('myReports.notified'),
  statuses: {
    pending: $ts('myReports.status.pending'),
    under_review: $ts('myReports.status.under_review'),
    actioned: $ts('myReports.status.actioned'),
    dismissed: $ts('myReports.status.dismissed'),
  },
  reasons: {
    illegal_content: $ts('myReports.reason.illegal_content'),
    fraud: $ts('myReports.reason.fraud'),
    defamation: $ts('myReports.reason.defamation'),
    hate_speech: $ts('myReports.reason.hate_speech'),
    harassment: $ts('myReports.reason.harassment'),
    spam: $ts('myReports.reason.spam'),
    inappropriate: $ts('myReports.reason.inappropriate'),
    impersonation: $ts('myReports.reason.impersonation'),
    intellectual_property: $ts('myReports.reason.intellectual_property'),
    privacy_violation: $ts('myReports.reason.privacy_violation'),
    other: $ts('myReports.reason.other'),
  },
  contentTypes: {
    review: $ts('myReports.contentType.review'),
    partner_listing: $ts('myReports.contentType.partner_listing'),
  },
}));
</script>
